import { render, staticRenderFns } from "./Highlight.vue?vue&type=template&id=6e2287ec"
import script from "./Highlight.vue?vue&type=script&lang=js"
export * from "./Highlight.vue?vue&type=script&lang=js"
import style0 from "./Highlight.vue?vue&type=style&index=0&id=6e2287ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports